import type { Pool, PoolUsage, CreatePoolRequest } from '@/types/pool.types';
import { ApiClient } from '@/config/axios.config';

export class PoolService {
  static async getAllPools(): Promise<Pool[]> {
    const pools = await ApiClient.get<
      { PoolId: number; Name: string; IsActive: boolean | number }[]
    >('/reference-data/pools/all');
    return pools.map((p) => ({
      poolId: p.PoolId,
      name: p.Name,
      isActive: Boolean(p.IsActive),
    }));
  }

  static async createPool(request: CreatePoolRequest): Promise<Pool> {
    return ApiClient.post<Pool>('/reference-data/pools', request);
  }

  static async togglePool(poolId: number): Promise<Pool> {
    return ApiClient.put<Pool>(`/reference-data/pools/${poolId}/toggle`);
  }

  static async getPoolUsage(poolId: number): Promise<PoolUsage> {
    return ApiClient.get<PoolUsage>(`/reference-data/pools/${poolId}/usage`);
  }

  static async deletePool(poolId: number): Promise<void> {
    await ApiClient.delete<void>(`/reference-data/pools/${poolId}`);
  }
}
